import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  NoticeCatalog,
  NoticeProof,
  NoticeScope,
  NoticeValidation,
  NoticeTerminologyFreshness,
} from './notice-fidelity.models';
const options = {
  withCredentials: true,
  headers: new HttpHeaders({
    'skip-error-interceptor': 'yes',
    'skip-loading-interceptor': 'yes',
  }),
};
@Injectable({ providedIn: 'root' })
export class NoticeFidelityService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);
  private get url(): string {
    return this.apis.core.manual.getPlatformNoticeFidelity();
  }
  catalog() {
    return this.http.get<NoticeCatalog>(this.url, options);
  }
  font(code: string) {
    return this.http.get(`${this.url}/fonts/${encodeURIComponent(code)}`, {
      ...options,
      responseType: 'arraybuffer',
    });
  }
  validate(scope: NoticeScope, sourceJson: string) {
    return this.http.post<NoticeValidation>(
      `${this.url}/validate`,
      {
        scopeTypeCode: scope.scopeTypeCode,
        scopeKey: scope.scopeKey,
        sourceJson,
      },
      options,
    );
  }
  render(
    scope: NoticeScope,
    sourceJson: string,
    savedSourceHash: string,
    exampleCode: string,
  ) {
    return this.http.post<NoticeProof>(
      `${this.url}/render`,
      {
        scopeTypeCode: scope.scopeTypeCode,
        scopeKey: scope.scopeKey,
        sourceJson,
        savedSourceHash,
        exampleCode,
      },
      options,
    );
  }
  terminologyFreshness(
    scope: NoticeScope,
    sourceJson: string,
    savedSourceHash: string,
    semanticHash: string,
  ) {
    return this.http.post<NoticeTerminologyFreshness>(
      `${this.url}/terminology-freshness`,
      {
        scopeTypeCode: scope.scopeTypeCode,
        scopeKey: scope.scopeKey,
        sourceJson,
        savedSourceHash,
        semanticHash,
      },
      options,
    );
  }
}
